export default {
  outList: [
    {
      light_point_1:[
        {
          title: '星空钻石前格栅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: '点阵式镀铬颗粒环抱奇瑞logo，呈现众星捧月般震撼视觉效果'
        }
      ],
      light_point_2:[
        {
          title: '灵眸透镜自动大灯',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '灵眸式设计布局时尚新潮，智能化自动大灯安全科技'
        },
      ],
      light_point_3:[
        {
          title: '风范橄榄灰新车色',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '源自奇瑞欧洲造型团队设计，引领时尚风潮'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '20.5吋超大智慧双联屏+雄狮智云交互系统',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '车内，语音轻松玩转世界。车外，7项手机远程控制功能'
        },
      ],
      light_point_2:[
        {
          title: '超大尺寸空间',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '超大乘坐+人性化使用空间，4358mm车长，1830mm车宽，2630mm轴距'
        }
      ],
      light_point_3:[
        {
          title: '米蓝双拼潮感舒享皮座椅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '内饰色彩源于欧洲莱茵河灵感呈现人体工程学设计，驾乘更舒适'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '风范橄榄灰新车色',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '源自奇瑞欧洲造型团队设计，引领时尚风潮'
    },
    {
      title: '星空钻石前格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '点阵式镀铬颗粒环抱奇瑞logo，呈现众星捧月般震撼视觉效果'
    },
    {
      title: '灵眸透镜自动大灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '灵眸式设计布局时尚新潮，智能化自动大灯安全科技'
    },
    {
      title: '米蓝双拼潮感舒享皮座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '内饰色彩源于欧洲莱茵河灵感呈现人体工程学设计，驾乘更舒适'
    }
  ],
  tab2: [
    {
      title: '20.5吋超大智慧双联屏+雄狮智云交互系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '车内，语音轻松玩转世界。车外，7项手机远程控制功能'
    },
    {
      title: '360°鸟瞰式超清全景影像',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '清除驾驶员视觉盲区。实现车辆精准操作'
    },
    {
      title: '超大尺寸空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '超大乘坐+人性化使用空间，4358mm车长，1830mm车宽，2630mm轴距'
    },
    {
      title: '一体化笼式车身',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '环状车身结构，钢架强度大幅提升，更安全'
    }
  ],
  tab3: [
    {
      title: '1.5L+9速CVT高效动力组合',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '整车起步加速提升10%，百公里综合油耗降幅0.5L'
    },
    {
      title: '1.5TCI+9速CVT白金动力组合',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '高效涡轮增压发动机，世界十佳变速器，115kW最大功率，230N·m峰值扭矩'
    }
  ]
}
